import React, { lazy } from 'react';
import { Quote } from 'lucide-react';
export const TrainingCommunity = () => {
  const testimonials = [{
    name: 'Blackman',
    city: 'Benin',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xg79LuBq9qCVoncHNm52aL/Blackman.png',
    quote: 'I attended the second edition in Benin city, and I was able to get a speaking gig that led to expanding my work to Abuja. The training opened doors I never expected.'
  }, {
    name: 'Ruth',
    city: 'Lagos',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2vwTMEx2nxEJnE1zhS1xa9/Ruth.png',
    quote: 'When I started my organization, I got guidance from the curator of The Networking Salon, and also access to trainers for my event. The support was invaluable.'
  }, {
    name: 'Emmanuel',
    city: 'Abuja',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8E7j4dJFgfCndoxPHot4Vw/Emmanuel.png',
    quote: 'The Networking Salon brought unexpected benefits beyond professional connections. The training sessions helped me rethink how I approach my career and well-being.'
  }];
  return <section className="py-20 bg-navy text-white relative overflow-hidden" data-id="element-1091" data-mp="16esfflw17owm">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-1092" data-mp="1b58z3nqg46rf"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-1093" data-mp="1k5fghkp9lqvv">
        <div className="max-w-4xl mx-auto text-center mb-16 scroll-animate" data-id="element-1094" data-mp="1k81lbckrtsae">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 font-heading" data-id="element-1095" data-mp="1p633zweabplc">
            Part of The Networking Salon Ecosystem
          </h2>
          <p className="text-xl text-gray-300" data-id="element-1096" data-mp="3qx6iiwrapob6">
            Training with us means more than just a workshop. Participants gain
            access to a powerful global network of:
          </p>
          <div className="flex flex-wrap justify-center gap-4 mt-8" data-id="element-1097" data-mp="3nus8kz16p8y1">
            <span className="bg-white/10 px-6 py-2 rounded-full font-medium border border-white/20" data-id="element-1098" data-mp="3nx4rbeernnc5">
              Professionals
            </span>
            <span className="bg-white/10 px-6 py-2 rounded-full font-medium border border-white/20" data-id="element-1099" data-mp="1o3rdv6icmoh">
              Creators
            </span>
            <span className="bg-white/10 px-6 py-2 rounded-full font-medium border border-white/20" data-id="element-1100" data-mp="3ssturstwpodq">
              Educators
            </span>
            <span className="bg-white/10 px-6 py-2 rounded-full font-medium border border-white/20" data-id="element-1101" data-mp="6ngfskd121t6">
              Entrepreneurs
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1102" data-mp="ff8jmc7jqcos">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white/5 border border-white/10 rounded-2xl p-8 flex flex-col items-center text-center scroll-animate hover:bg-white/10 transition-colors duration-300" style={{
          transitionDelay: `${index * 100}ms`
        }} data-id="element-1103" data-mp="ubzo2zw2uel9" data-mpi={index}>
              <div className="w-20 h-20 rounded-full overflow-hidden border-2 border-gold/50 shadow-lg mb-5" data-id="element-1104" data-mp="1czi9xqo4hyif">
                <img src={testimonial.image} alt={testimonial.name} className="w-full h-full object-cover" loading="lazy" data-id="element-1105" data-mp="z0ihe7xhozgz" />
              </div>
              <Quote className="w-8 h-8 text-gold/40 mb-4" data-id="element-1106" data-mp="p9e7hmmo84t0" />
              <p className="text-gray-300 italic leading-relaxed mb-6 text-sm flex-grow" data-id="element-1107" data-mp="u3ici0cdm2rg">
                "{testimonial.quote}"
              </p>
              <div className="mt-auto pt-4 border-t border-white/10 w-full" data-id="element-1108" data-mp="l9n9oyyq8oez">
                <p className="font-bold text-white" data-id="element-1109" data-mp="l7j6ykckdvga">{testimonial.name}</p>
                <p className="text-sm text-gray-400" data-id="element-1110" data-mp="6cwhpardueze">{testimonial.city}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};